import { c as _c } from "react/compiler-runtime";
import { colors, Stack } from '@newfront-insurance/core-ui';
import type { NextApiErrorLike } from '@newfront-insurance/data-layer-http';
import type { JSX } from 'react';
import styled from 'styled-components';
import { isNextApiErrorLike } from '../../../next-api-error/error';
interface ErrorDetailsProps {
  error: NextApiErrorLike | Error;
}

/**
 * Render more information about the error, including the stack trace.
 */
export function ErrorDetails(t0) {
  const $ = _c(20);
  const {
    error
  } = t0;
  if (isNextApiErrorLike(error)) {
    let t1;
    if ($[0] !== error.method || $[1] !== error.url) {
      t1 = <StyledPre>{error.method} {error.url}</StyledPre>;
      $[0] = error.method;
      $[1] = error.url;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] !== error.data) {
      t2 = JSON.stringify(error.data, null, 2);
      $[3] = error.data;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== t2) {
      t3 = <StyledPre>{t2}</StyledPre>;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== error.stack) {
      t4 = <StyledPre>{error.stack}</StyledPre>;
      $[7] = error.stack;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t1 || $[10] !== t3 || $[11] !== t4) {
      t5 = <Stack gap={8} direction="vertical">{t1}{t3}{t4}</Stack>;
      $[9] = t1;
      $[10] = t3;
      $[11] = t4;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    return t5;
  }
  let t1;
  if ($[13] !== error.message) {
    t1 = <StyledPre>{error.message}</StyledPre>;
    $[13] = error.message;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  let t2;
  if ($[15] !== error.stack) {
    t2 = <StyledPre>{error.stack}</StyledPre>;
    $[15] = error.stack;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[17] !== t1 || $[18] !== t2) {
    t3 = <Stack gap={8} direction="vertical">{t1}{t2}</Stack>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  return t3;
}
const StyledPre = styled.pre`
  background-color: ${colors.steel[100]};
  display: block;
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  line-height: 16px;
  color: ${colors.steel[400]};
  overflow-x: scroll;
  margin: 0;
`;